import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import { extend, wpComponents, vuetifyComponents } from './../../components';
import ru from 'vuetify/src/locale/ru';
import colors from 'vuetify/lib/util/colors';
import { Resize, Scroll } from 'vuetify/lib/directives';
import VdnhSale from './vdnh-sale';
import VdnhTariffItem from './../VdnhTariffItem/vdnh-tariff-item';
import VdnhTariffBundle from './../VdnhTariffItem/vdnh-tariff-bundle';

wpComponents['wp-sale'] = VdnhSale;
wpComponents['wp-tariff-item'] = VdnhTariffItem;
wpComponents['wp-tariff-bundle'] = VdnhTariffBundle;


const allComponents = extend(wpComponents, vuetifyComponents);

Vue.use(Vuetify, { components: allComponents, directives: { Resize, Scroll } });

export default new Vuetify({
    lang: {
        locales: { ru },
        current: 'ru'
    },
    theme: {
        themes: {
            light: {
                secondary: colors.blue.lighten3
            }
        }
    }
});
